import axios from "axios";
import { API_BASE } from "@/lib/apiBase";

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const money = (n) =>
  (n ?? 0).toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });

export const todayLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const weekDates = (anchor) => {
  const d = new Date(anchor + "T12:00:00");
  const monday = new Date(d);
  monday.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return Array.from({ length: 7 }, (_, i) => {
    const day = new Date(monday);
    day.setDate(monday.getDate() + i);
    return `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, "0")}-${String(day.getDate()).padStart(2, "0")}`;
  });
};

export const prettyDate = (iso) =>
  new Date(iso + "T12:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });

export const prettyTs = (iso) => {
  try {
    return new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const VEHICLE_STYLES = {
  available: "border-aqua/50 bg-aqua/10 text-aqua",
  reserved: "border-sky-500/40 bg-sky-400/10 text-sky-700",
  in_use: "border-yellow-500/40 bg-yellow-400/10 text-yellow-700",
  maintenance: "border-orange-500/40 bg-orange-400/10 text-orange-700",
  out_of_service: "border-red-500/40 bg-red-400/10 text-red-600",
};

export const RES_STYLES = {
  upcoming: "border-sky-500/40 bg-sky-400/10 text-sky-700",
  checked_in: "border-aqua/50 bg-aqua/10 text-aqua",
  launched: "border-yellow-500/40 bg-yellow-400/10 text-yellow-700",
  completed: "border-emerald-500/40 bg-emerald-400/10 text-emerald-700",
  cancelled: "border-black/20 bg-black/5 text-muted",
  no_show: "border-red-500/40 bg-red-400/10 text-red-600",
};

export const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();
    reader.onload = (e) => {
      img.onload = () => {
        const scale = Math.min(1, 1000 / img.width);
        const canvas = document.createElement("canvas");
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", 0.7));
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
